const translateDocumentName = (documentName, locale, t) => {
  if (documentName === "New document" && locale !== "en") {
    return t("creator.new_document");
  }

  return documentName;
};

export default translateDocumentName;
